import React, {
  useContext,
  createContext,
  useMemo,
  useState,
  useCallback,
} from 'react';

import PropTypes from 'prop-types';

import { MODEL_SIZES_MAP } from '~/shared/utils/sizeConstants';
import { useModelImageContext } from '~/techstyle-shared/react-components';

const Context = createContext();

export const useMemberModelContext = () => useContext(Context);

export default function EnhancedMemberModelProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { activeModel } = useModelImageContext();

  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  const hasModelInfo = useMemo(() => {
    if (!activeModel) {
      return false;
    }

    const hasSizeInfo = Object.values(MODEL_SIZES_MAP).some(
      (modelSize) => modelSize.key && activeModel[modelSize.key]
    );

    return hasSizeInfo && activeModel.heightInInches;
  }, [activeModel]);

  const context = useMemo(
    () => ({
      openModal,
      closeModal,
      isModalOpen,
      hasModelInfo,
    }),
    [openModal, closeModal, isModalOpen, hasModelInfo]
  );
  return <Context.Provider value={context}>{children}</Context.Provider>;
}

EnhancedMemberModelProvider.propTypes = {
  children: PropTypes.node,
};
